import { parseScenarioField } from './scenarioNumbers'

// Each %/$ toggle, the stored dollar override it switches to, and the computed figure its dollar box
// shows in % mode (the same keys the rows read; reilm-be flip/*.js for which override each toggle uses).
const DOLLAR_OVERRIDES = {
  buy_commission: { field: 'agent_commission2', read: (c) => c?.agentFee },
  insurance_policy: { field: 'insurance_policy2', read: (c) => c?.insurance },
  buy_title_fee: { field: 'title_fees2', read: (c) => c?.titleFees },
  financed_down_payment: { field: 'financed_down_payment2', read: (c) => c?.downPaymentDollar },
  origination: { field: 'origination_points1', read: (c) => c?.originationFee },
  selling_commission: { field: 'selling_commission1', read: (c) => c?.sellingCostRows?.agentCommissions },
  concessions_to_buyer: { field: 'concessions_to_buyer2', read: (c) => c?.sellingCostRows?.sellerCredits },
  br4_ltv: { field: 'br4_ltv2', read: (c) => c?.refiLoanAmount },
  br4_loan_cost: { field: 'br4_loan_cost2', read: (c) => c?.refiLoanCosts },
}

// % -> $ keeps the dollar figure the % gave instead of the old override (or 0) -- Cong, letter 99,
// item 7 "Toggles" 2. Kept to the cent, so the switch itself moves no total.
export function isDollarSwitch(toggleKey, previous, next) {
  return Boolean(DOLLAR_OVERRIDES[toggleKey]) && next === '$' && previous !== '$'
}

function seedValue(entry, computed) {
  const figure = entry.read(computed)
  if (typeof figure !== 'number' || !Number.isFinite(figure)) return null
  return parseScenarioField(entry.field, Math.round(figure * 100) / 100)
}

// { field, value } for the row's dollar override, or null when `computed` has no figure for it.
export function dollarSeed(toggleKey, computed) {
  const entry = DOLLAR_OVERRIDES[toggleKey]
  const value = entry ? seedValue(entry, computed) : null
  return value == null ? null : { field: entry.field, value }
}

// Whether `computed` (calculated from `computedInput`) still holds for the compute body on screen:
// the two may differ only by % -> $ switches seeded with that same computed figure, which change no
// figure (README.md, "Switching % -> $ keeps the figure").
export function computedStillCurrent(body, computedInput, computed) {
  if (computed == null || computedInput == null || body == null) return false
  const input = { ...computedInput, toggles: { ...(computedInput.toggles ?? {}) } }
  for (const [toggleKey, entry] of Object.entries(DOLLAR_OVERRIDES)) {
    const seeded = body.toggles?.[toggleKey] === '$' && input.toggles[toggleKey] !== '$'
    if (seeded && body[entry.field] != null && body[entry.field] === seedValue(entry, computed)) {
      input.toggles[toggleKey] = '$'
      input[entry.field] = body[entry.field]
    }
  }
  return sameValue(body, input)
}

function sameValue(a, b) {
  if (a === b) return true
  if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') return false
  if (Array.isArray(a) !== Array.isArray(b)) return false
  const keys = new Set([...Object.keys(a), ...Object.keys(b)])
  for (const key of keys) if (!sameValue(a[key], b[key])) return false
  return true
}
